export default __webpack_public_path__ + "media/images/logo-868ceb9a2bda7f2d24d08191072775e7.svg";